import { UserX } from "react-feather";
import StatsComponent from "./component";
import { StatsComponentWrapper, StatsMainWrapper, StatsDivider } from "./style";
import { useGetTheme } from "../../lib/contexts";
import { useEffect, useState } from "react";
import { getTeams, getPositions, getNumMarkets } from "../../lib/api/data";

const Stats = () => {
  const [apiStats, setApiStats] = useState({
    num_teams: 0,
    num_positions: 0,
    num_markets: 0,
  });
  const {theme} = useGetTheme();

  async function loadApiStats() {
    let n_teams = 0;
    let n_positions = 0;
    let n_markets = 0;
    let resp = await getTeams();
    if (resp && resp.status === 200) {
      n_teams = resp.data.length;
    }
    resp = await getPositions();
    if (resp && resp.status === 200) {
      n_positions = resp.data.length;
    }
    resp = await getNumMarkets();
    if (resp && resp.status === 200) {
      n_markets = resp.data.num_markets;
    }
    const data = {
      num_teams: n_teams,
      num_positions: n_positions,
      num_markets: n_markets,
    }
    setApiStats({...data});
  }

  useEffect(() => {
    loadApiStats()
  },[])

  return (
    <StatsMainWrapper color={"transparent"}>
      <StatsComponentWrapper>
        <StatsDivider color={theme === 'dark' ? "#303030" : "lightgrey"}/>
        <StatsComponent
          count={apiStats.num_teams}
          title={"Teams"}
          subtitle={"from dozens of sports leagues, including the NFL, NBA, NHL, MLB, MLS, ATP, and more."}
          IconName={UserX}
          theme={theme}
          addPlus={false}
        />
        <StatsDivider color={theme === 'dark' ? "#303030" : "lightgrey"}/>
        <StatsComponent
          count={apiStats.num_positions}
          title={"Position Types"}
          subtitle={"including mainlines, alternate lines, player/team/game props, and more."}
          IconName={UserX}
          theme={theme}
          addPlus={false}
        />
        <StatsDivider color={theme === 'dark' ? "#303030" : "lightgrey"}/>
        <StatsComponent
          count={apiStats.num_markets}
          title={"Data Points"}
          subtitle={"historial data points for prediction market positions, including lines, odds, and more."}
          IconName={UserX}
          theme={theme}
          addPlus={false}
        />
        <StatsDivider color={theme === 'dark' ? "#303030" : "lightgrey"}/>
      </StatsComponentWrapper>
    </StatsMainWrapper>
  );
};

export default Stats;